import { render, staticRenderFns } from "./jiyou.vue?vue&type=template&id=52d5ddfb"
import script from "./jiyou.vue?vue&type=script&lang=js"
export * from "./jiyou.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports